export default "__VITE_ASSET__DKVNOnt3__"